import _ from 'lodash'
import config from 'scoreboard/components/config'

/**
 * Determines if a score object has any unapproved values
 */
function hasUnapprovedValues(score) {
	if (!config.kpiValuesRequireApproval || !score) return false

	return (score.actualChanged || score.applicableChanged ||
		_.get(score, 'changedThresholds', []).some(t => t))
}

/**
 * Ensure that the unapproved values on a score object have the correct values
 */
function setupUnapprovedValues(score) {
	// #39001 when the configuration option is off, we still need to setup
	// the unapproved values so saving changes works correctly. But when it
	// is off, we need to ignore the values originally in the unapproved properties

	if (!score.actualChanged) {
		score.unapprovedActual = score.actual
	}

	if (!score.applicableChanged) {
		score.unapprovedApplicable = score.applicable
	}

	// #38576 Make sure the final `score.unapprovedThresholds` array includes
	// all the thresholds that are applicable to this score
	if (score.thresholds) {
		if (!score.unapprovedThresholds) {
			// #39100 make sure we always have an unapproved array
			score.unapprovedThresholds = new Array(score.thresholds.length).fill(null)
		}
		for (let i = 0; i < score.thresholds.length; i++) {
			if (!score.changedThresholds || !score.changedThresholds[i]) {
				score.unapprovedThresholds[i] = score.thresholds[i]
			}
		}
	}
}

export { hasUnapprovedValues, setupUnapprovedValues }